// extracted by mini-css-extract-plugin
export var active = "_e4-2";
export var recordingDot = "_e4-1";
export var recordingIndicator = "_e4-0";